import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiShield, FiEye, FiMapPin, FiSmartphone } = FiIcons;

const TrustStrip = () => {
  const trustPoints = [
    { icon: FiClock, text: 'Reliable, on-time delivery' },
    { icon: FiShield, text: 'Safety and quality focused' },
    { icon: FiEye, text: 'Transparent inclusions' },
    { icon: FiMapPin, text: 'Built for local trades' },
    { icon: FiSmartphone, text: 'Fast, mobile-first performance' }
  ];

  return (
    <section className="py-12 bg-black/30 backdrop-blur-sm border-y border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-4">
          {trustPoints.map((point, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex items-center justify-center text-center lg:text-left"
            >
              <div className="flex flex-col lg:flex-row items-center gap-3">
                <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-2 rounded-lg">
                  <SafeIcon icon={point.icon} className="w-5 h-5 text-white" />
                </div>
                <p className="text-white font-medium text-sm lg:text-base">
                  {point.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;